import styled from 'styled-components';
import {palette} from 'styled-theme';

const Wrapper = styled.div``;

export const ProfilePage = styled.div`
  min-height: 100%;
  background: #f5f7fb;

  .profile-container {
    position: relative;
  }

  .profile-card {
    margin-top: -96px;
    margin-bottom: 32px;
    border-radius: 8px;
    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.1);
    overflow: visible;
  }

  .profile-card .ant-card-head {
    min-height: 72px;
    padding: 0 28px;
    border-bottom-color: #eef1f5;
  }

  .profile-card .ant-card-head-title {
    padding: 16px 0;
  }

  .profile-card .ant-card-body {
    padding: 32px 28px 28px;
  }

  .profile-card-actions {
    display: flex;
    justify-content: flex-end;
  }

  .profile-reset-button {
    height: 40px;
    border-radius: 6px;
    font-weight: 500;
  }

  @media only screen and (max-width: 767px) {
    background: #f4f6fa;

    .profile-container {
      padding-left: 16px;
      padding-right: 16px;
    }

    .profile-card {
      margin-top: 0;
      margin-bottom: 20px;
      border-radius: 8px;
      box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
    }

    .profile-card .ant-card-head {
      min-height: auto;
      padding: 0 16px;
    }

    .profile-card .ant-card-body {
      padding: 18px 16px 20px;
    }

    .profile-card-actions {
      justify-content: stretch;
    }

    .profile-reset-button {
      width: 100%;
    }
  }
`;

export const Banner = styled.div`
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 400px;
  position: relative;
  &::after {
    content: '';
    height: 160px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background: linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.41));
  }

  .container {
    height: 400px;
    position: relative;
    z-index: 1;
    .avatar-card {
      position: absolute;
      bottom: -42px;
      left: 30px;
      pointer-events: none;
      width: calc(100% - 60px);
      max-width: 20rem;
      @media only screen and (max-width: 767px) {
        bottom: -35px;
      }
      @media only screen and (max-width: 667px) {
        bottom: 20px;
      }
      .avatar {
        @media only screen and (max-width: 767px) {
          width: 160px;
          height: 160px;
        }
        @media only screen and (max-width: 667px) {
          width: 140px;
          height: 140px;
        }
        @media only screen and (max-width: 480px) {
          width: 100px;
          height: 100px;
          border-width: 3px;
        }
      }
      .info {
        @media only screen and (max-width: 767px) {
          padding-left: 15px;
          width: calc(100% - 160px);
        }
        @media only screen and (max-width: 667px) {
          width: calc(100% - 140px);
        }
        @media only screen and (max-width: 480px) {
          width: calc(100% - 100px);
        }
        h3 {
          font-size: 24px;
          line-height: 36px;
          font-weight: 500;
          color: #ffffff;
          pointer-events: all;
          @media only screen and (max-width: 667px) {
            font-size: 22px;
            line-height: 34px;
          }
          @media only screen and (max-width: 480px) {
            font-size: 18px;
            line-height: 30px;
          }
        }
        p {
          color: #ffffff;
          font-size: 14px;
          line-height: 24px;
          pointer-events: all;
        }
      }
    }
  }

  @media only screen and (max-width: 767px) {
    height: 180px;
    background-position: center top;

    &::after {
      height: 100%;
      background: linear-gradient(180deg, rgba(14, 32, 56, 0.1), rgba(14, 32, 56, 0.54));
    }

    .container {
      height: 180px;
      padding-left: 16px;
      padding-right: 16px;
    }
  }
`;

export const Navigation = styled.div`
  background-color: transparent;
  pointer-events: all;
  box-shadow: none;

  .ant-tabs-nav {
    margin-bottom: 20px;
  }

  .ant-tabs-tab {
    padding: 16px 0;
    font-size: 15px;
    font-weight: 500;
  }

  ul.menu {
    display: flex;
    align-items: center;
    justify-content: center;
    @media only screen and (max-width: 667px) {
      justify-content: flex-start;
    }
    li {
      margin: 0 15px;
      display: block;
      padding: 18px 15px 19px;
      color: ${palette('secondary', 5)};
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
      @media only screen and (max-width: 320px) {
        margin: 0 7px;
      }
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      strong {
        font-size: 18px;
        font-weight: 600;
        margin-right: 4px;
      }
      &.active {
        border-bottom: 2px solid ${palette('secondary', 5)};
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .ant-tabs-nav {
      margin-bottom: 12px;
    }

    .ant-tabs-nav::before {
      border-bottom: 0;
    }

    .ant-tabs-tab {
      padding: 12px 0;
      font-size: 14px;
    }
  }
`;

export const ContentWrapper = styled.div`
  padding: 30px 0;
`;

export default Wrapper;
